/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import Timeout from "await-timeout";
import * as Yup from "yup";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import { LabSelect } from "../select";
import { InputTitle, Label } from "./styles";
import { fetchAllClientes } from "../../../services/clientesServices";
import { getSubclientesByClientId, updateClientGroup, createClientGroup } from "../../../services/labServices";

const createOrUpdateClientGroup = async (data, id) => {
  if (id) {
    const { message } = await updateClientGroup(id, data);
    toast.success(message);
    return true;
  }

  const { message } = await createClientGroup(data);
  toast.success(message);
  return true;
};

export const formatNumeroDeLegajo = (numeroDeLegajo) => {
  // Elimina cualquier decimal al final del número de legajo
  let legajo = numeroDeLegajo.replace(/\.\d+$/, "");

  // Agrega ceros adelante si el número de legajo tiene menos de 7 dígitos
  while (legajo.length < 7) {
    // eslint-disable-next-line prefer-template
    legajo = "0" + legajo;
  }

  return legajo;
};

const ClientGroupForm = ({ toggle, groupInfo, reload }) => {
  const [clientId, setClientId] = useState(groupInfo && groupInfo.labRelsGroupClienteSubclient ? groupInfo.labRelsGroupClienteClient[0].id : 0);
  const [allClientes, isLoadingAllClientes] = useFetcher(fetchAllClientes, undefined, "fetchAllClientes");
  const [subClients, isLoadingSubClients] = useFetcher(getSubclientesByClientId, [clientId]);
  const [clienteSelected, setClienteSelected] = useState(
    groupInfo && groupInfo.labRelsGroupClienteClient
      ? { label: groupInfo.labRelsGroupClienteClient[0].razonSocial, value: groupInfo.labRelsGroupClienteClient[0].id }
      : null
  );
  const [subClientsSelected, setSubClientsSelected] = useState(
    groupInfo && groupInfo.labRelsGroupClienteSubclient
      ? groupInfo.labRelsGroupClienteSubclient.map((e) => ({ label: `${formatNumeroDeLegajo(e.numeroDeLegajo)}`, value: e.itemId }))
      : []
  );

  //---------------------------------------------------------------------

  const allClientesOptions = allClientes.rows
    ? allClientes.rows.map((razon) => {
        return { label: razon.razonSocial, value: razon.id };
      })
    : [];

  const subClientesOptions =
    subClients && subClients.length > 0
      ? subClients
          .map((e) => {
            return { label: `${formatNumeroDeLegajo(e.numeroDeLegajo)}`, value: e.itemId };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  //---------------------------------------------------------------------

  function getFunctionToFilter(filter, selected) {
    if (filter === "clientes") {
      setClienteSelected(selected);
      if (selected) {
        setClientId(selected.value);
        setSubClientsSelected([]);
      } else {
        setClientId(0);
        setSubClientsSelected([]);
      }
    }
    if (filter === "subClient") {
      setSubClientsSelected(selected);
    }
  }

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const formik = useFormik({
    initialValues: {
      name: groupInfo ? groupInfo.name : "",
      clientes: [],
    },
    onSubmit: async (values) => {
      const dataToEdit = {
        ...values,
        clientes: clienteSelected ? [clienteSelected.value] : [],
        subclientes: subClientsSelected.length > 0 ? subClientsSelected.map((e) => e.value) : [],
      };

      if (!clienteSelected) {
        toast.error("Debe seleccionar al menos una region");
        return;
      }

      try {
        await createOrUpdateClientGroup(dataToEdit, groupInfo ? groupInfo.id : null);
        await Timeout.set(1000);
        toggle();
        reload();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Este campo es requerido."),
    }),
  });

  const clienteError = () => {
    const error = { error: false };

    if (!clienteSelected) {
      error.clientes = "Debe seleccionar un cliente";
    }

    return error;
  };
  const messageError = clienteError();
  return (
    <>
      <form className="theme-form" onSubmit={formik.handleSubmit}>
        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
          <div className="col-sm-9">
            <div className="form-group">
              <Label htmlFor="name" className="col-form-label pt-0 w-100" style={formik.errors.name && formik.touched.name ? { color: "red" } : null}>
                Nombre del grupo
                <InputTitle
                  name="name"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  placeholder={formik.errors.name && formik.touched.name ? formik.errors.name : "Nombre del grupo"}
                  style={formik.errors.name && formik.touched.name ? { borderBottom: "1px solid red" } : null}
                />
              </Label>
            </div>
          </div>
          <div className="col-sm-9">
            <div className="form-group">
              <Label htmlFor="clientes" className="col-form-label pt-0 w-100" style={messageError.clientes && formik.touched.clientes ? { color: "red" } : null}>
                Razon Social
                <LabSelect
                  id="clientes"
                  name="clientes"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={clienteSelected}
                  placeholder="Seleccionar"
                  isClearable
                  isLoading={isLoadingAllClientes}
                  options={allClientesOptions}
                />
                {messageError.clientes && formik.touched.clientes && <div className="input-feedback">{messageError.clientes}</div>}
              </Label>
            </div>
          </div>
          <div className="col-sm-9">
            <div className="form-group">
              <Label htmlFor="subClient" className="col-form-label pt-0 w-100">
                Sub Cliente
                <LabSelect
                  isMulti
                  id="subClient"
                  name="subClient"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={clienteSelected ? subClientsSelected : null}
                  placeholder="Todo"
                  isClearable
                  isLoading={isLoadingSubClients}
                  options={subClientesOptions}
                  disabled={isLoadingSubClients}
                />
              </Label>
            </div>
          </div>
        </div>
        <div className=" mt-3 mb-0 d-flex justify-content-end">
          <Button color="btn-secondary mr-2" onClick={toggle}>
            Cancelar
          </Button>
          <button className="btn btn-success" isLoading={formik.isSubmitting} disabled={formik.isSubmitting} type="submit">
            Guardar
          </button>
        </div>
      </form>
    </>
  );
};

export default ClientGroupForm;
